<template>
<div class="tool-bar-box">
    <div class="tool-bar">
        <div class="tool-item" v-if=backShow>
            <span class="dropdown-label">
                <span class="icons icon-back"></span>                                
                <span class="" @click="goBack">返回</span>
            </span>
        </div>
        <div class="tool-item dropdown" v-if=selectShow>
            <dropdown :visible="selectVisible" @mouseout="selectVisible = false" :margin=[0,-10]>
                <span @mouseover="selectVisible = true" class="dropdown-label">
                    <checkbox v-model="checkAll" :callback=setCheckAllIds :data="true"></checkbox>
                    <!-- <span class="icons" :class="selectAll==1?'icon-checked':'icon-unchecked'"  @click="selectAllChecked"></span>                 -->
                    <span class="name">选择</span>
                    <span class="more"></span>
                </span>
                <ul class="dropdown-list fix" slot="dropdown">
                    <li @click="selectAllChecked">全选/取消</li>
                    <li @click="selectReadOrNot(false)">未读邮件</li>
                    <li @click="selectReadOrNot(true)">已读邮件</li>
                </ul>
            </dropdown>
        </div>
        <div class="tool-item dropdown">
            <dropdown :visible="deleteVisible" @mouseout="deleteVisible = false" :margin=[0,-10] v-if="!hideDelBtn">
                <span @mouseover="deleteVisible = true" class="dropdown-label">
                    <span class="icons icon-delete"></span>                                
                    <span class="">删除</span>
                    <span class="more"></span>
                </span>
                <ul class="dropdown-list fix" slot="dropdown">
                    <li class="" @click="mailsOperate({op:'move', to:mailFolders.deleted.folder_id,del:true})">删除</li>
                    <li class="" @click="mailsOperate({op:'del'})">彻底删除</li>
                </ul>
            </dropdown>
            <span @mouseover="deleteVisible = true" class="dropdown-label" v-else>
                    <span class="icons icon-delete"></span>                                
                    <span class="" @click="mailsOperate({op:'del'})">彻底删除</span>
            </span>
        </div>
        <div class="tool-item dropdown" v-if="!isDraft">
            <dropdown :visible="markVisible" @mouseout="markVisible = false" :margin=[0,-10]>
                <span @mouseover="markVisible = true" class="dropdown-label">
                    <span class="icons icon-mark"></span>                                
                    <span class="">标记</span>
                    <span class="more "></span>
                </span>
                <ul class="dropdown-list fix" slot="dropdown">
                    <li class="" @click="mailsOperate({op:'markRead',read:1})">已读</li>
                    <li class="" @click="mailsOperate({op:'markRead',read:0})">未读</li>
                    <li class="" @click="mailsOperate({op:'markStar',star:1})">标记星标</li>
                    <li class="" @click="mailsOperate({op:'markStar',star:0})">取消星标</li>
                </ul>
            </dropdown>
        </div>
        <div class="tool-item dropdown" v-if="!isDraft">
            <dropdown :visible="moveVisible" @mouseout="moveVisible = false" :margin=[0,-10]>
                <span @mouseover="moveVisible = true" class="dropdown-label">
                    <span class="icons icon-move-two"></span>                                
                    <span class="">移至</span>
                    <span class="more "></span>
                </span>
                <ul class="dropdown-list fix" slot="dropdown">
                    <li class="" @click="mailsOperate({op:'move',to:mailFolders.recv.folder_id})" v-if="mailFolders.recv&&!showMoveById(mailFolders.recv.folder_id)">收件箱</li>
                    <li class="" @click="mailsOperate({op:'move',to:mailFolders.send.folder_id})" v-if="mailFolders.send&&!showMoveById(mailFolders.send.folder_id)">已发送</li>
                    <li class="" @click="mailsOperate({op:'move',to:mailFolders.deleted.folder_id})" v-if="mailFolders.deleted&&!showMoveById(mailFolders.deleted.folder_id)">已删除</li>
                    <li class="" @click="mailsOperate({op:'move',to:mailFolders.spam.folder_id})" v-if="mailFolders.spam&&!showMoveById(mailFolders.spam.folder_id)">垃圾邮件</li>                    
                    <!-- <li class="" v-for="(folder,index) in mailFolders.multiMails" @click="mailsOperate({op:'move',to:folder.folder_id})" v-show="!showMoveById(folder.folder_id)" :key=index>{{folder.name}}</li> -->
                    <li class="" v-for="(folder,index) in mailFolders.other" @click="mailsOperate({op:'move',to:folder.folder_id})" v-show="!showMoveById(folder.folder_id)" :key=index>{{folder.name}}</li> 
                </ul>
            </dropdown>
        </div>
        <div class="tool-item dropdown" v-if="sortShow">
            <dropdown :visible="sortVisible" @mouseout="sortVisible = false" :margin=[0,-10]>
                <span @mouseover="sortVisible = true" class="dropdown-label">
                    <span class="icons icon-sort"></span>                                
                    <span class="">排序</span>
                    <span class="more "></span>
                </span>
                <ul class="dropdown-list fix" slot="dropdown">
                    <li class="" @click="sortOp(0)">从新往旧</li>
                    <li class="" @click="sortOp(1)">从旧往新</li>
                </ul>
            </dropdown>
        </div>
        <div class="tool-item tool-spam" @click="spamMails" v-if="showSpam">
            <span class="icons icon-spam"></span> 举报
        </div>
        <div class="tool-item fr tool-item-set" v-if=!backShow>
            <dropdown :visible="setVisible" @mouseout="setVisible = false" :position="['left','bottom','right','top']" :margin=[24,-20]>
            <span @mouseover="setVisible = true" class="dropdown-label setting">            
                <span class="icons icon-setcolumn"></span>    
            </span>        
            <div class="toolsetting" slot="dropdown">
                <div class="item">
                    <label>分栏模式</label>
                    <span class="setting-btn" :class='{"active":!column}' @click="setcolumn(false)">关闭</span>
                    <span class="setting-btn" :class='{"active":column}' @click="setcolumn(true)">开启</span>
                </div>
                <!-- 隐藏功能 -->
                <!-- <div class="item">
                    <label>会话模式</label>
                    <span class="setting-btn" :class='{"active":!dialog}' @click="setdialog(false)">关闭</span>
                    <span class="setting-btn" :class='{"active":dialog}' @click="setdialog(true)">开启</span>
                </div>                 -->
            </div>
            </dropdown>
            
        </div>
        <slot name="pages"></slot>
        <!-- <div class="fr" slot="pages">
            <span class="dropdown-label" style="margin-right:18px;">
                <span class="icons icon-next-mail"></span>                                
            </span>
            <span class="dropdown-label">
                <span class="icons icon-pre-mail"></span>                                
            </span>
        </div> -->
    </div>
    <!-- <report-spam :sshow.sync="reportSpamShow" :ids=ids></report-spam> -->
</div>
</template>
<script>
import { mailsOperate, showMoveById } from '@/service/mailopService'
import {mapState, mapActions} from 'vuex'
import { checkbox, radio } from '@/components/check'
// import reportSpam from '@/components/reportSpam'
import router from '@/router'

export default {
    name:'mailToolBar',
    props: {
        ids:{
            type: Array,
            default: ()=>[]
        },
        selectAll:[Boolean, Number],
        callback:{
            type: Function,
        },
        backShow:{
            type:Boolean,
            default:false
        },
        selectShow:{
            type:Boolean,
            default:false
        },
        sortShow:{
            type:Boolean,
            default:false
        },
        isDraft:{
            type:Boolean,
            default:false
        },
        hideDelBtn:{
            type:Boolean,
            default:false
        }
    },
    created(){
        this.initData()
    },
    data () {
        return {
            selectVisible:false,
            deleteVisible:false,
            markVisible:false,
            sortVisible:false,
            moveVisible:false,
            setVisible:false,
            todayShow:true,
            earlyShow:true,
            checkAll:false,
            selectIds:this.ids,
            // reportSpamShow:false
        }
    },
    computed: {
        ...mapState([
            'list',
            'folderId',
            'mailSort',
            'mailFolders',
            'mailsList',
            'userInfo',
            'column',
            'dialog'
        ])
    },
    components:{
        checkbox,
        // "report-spam":reportSpam
    },
    methods: {
        ...mapActions([
    		'getFolders'
        ]),
        showMoveById,
        initData(){
            this.name=this.$route.path.split('/')[2]
            this.showSpam=['draft','deleted','send','spam'].indexOf(this.name)==-1
        },
        goBack() {
            let path=this.$route.path.split('/')
            path.pop()
            router.push({path:path.join('/'),query:{id:this.$route.params.id,keyword:this.$route.query.keyword}})
        },
        selectAllChecked(){
            this.checkAll = !this.checkAll
            this.setCheckAllIds()
        },
        setCheckAllIds(){
            this.selectIds=[]
            if(this.checkAll) {
                for(let i=0;i<this.mailsList.length;i++){
                    for(let j=0;j<this.mailsList[i].mails.length;j++){
                        this.selectIds.push(this.mailsList[i].mails[j].id)
                    }
                }
            }                                   
            this.$emit("on-result-change",this.selectIds)
        },
        selectReadOrNot(isread){
            this.selectVisible=false
            this.selectIds=[]                        
            for(let i=0;i<this.mailsList.length;i++){
                for(let j=0;j<this.mailsList[i].mails.length;j++){
                    let mail=this.mailsList[i].mails[j]
                    if(mail.hasRead){
                        isread&&this.selectIds.push(this.mailsList[i].mails[j].id)
                    }else{
                        !isread&&this.selectIds.push(this.mailsList[i].mails[j].id)          
                    }
                }
            }
            this.$emit("on-result-change",this.selectIds)
        },
        spamMails(){
            if(this.ids.length<=0){
                this.$toast({
                    message: '请选择邮件',
                    theme: 'warning'
                })
                return
            }
            this.$reportSpam({
                show:true,
                ids:this.ids,
                list:this.list,
                folderId:this.folderId,
                callback:this.callback
            })
            // this.reportSpamShow=true
        },
        sortOp(v){
            this.$store.commit('CHANGE_MAILSORT',v)
        },
        mailsOperate(obj){
            var newObj=Object.assign({ids:this.ids,callback:this.callback,folderId:this.folderId},obj)
            if(!this.ids.length){
                this.$emit("on-idempty",false) 
            }
            mailsOperate(newObj)          
        },
        setcolumn(val){
            if(this.column==val){
                return
            }
            this.$store.commit('SET_COLUMN',val)
        },
        setdialog(val){
            if(this.dialog==val){
                return
            }
            this.$store.commit('SET_DIALOG',val)
        }
    },
    watch:{
        selectAll:function(){
            this.checkAll = Boolean(this.selectAll==1&&this.ids.length)
        },
        '$route':function(){
            this.initData()

        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../assets/style/variables';
.tool-bar-box{
    position: fixed;
    width: calc(100% - 200px);
    background: #fff;
    z-index: 222;
    font-size: 14px;
    color:$dim-gray-color;
    height: 46px;
    border-bottom: 1px solid $light-gray-color;
    padding:6px 16px;
    min-width: 800px;
    .tool-item{
        display: inline-block;
        margin-right: 40px;
        .dropdown-label{
            display: inline-block;
            padding:10px 0;                            
            cursor: pointer;
            &.setting{
                padding-left:16px;
            }
        }
        .check{
            margin-right: 4px;
            margin-top: -1px;
            display: inline-block;
        }
        .dropdown-list{
            width: 100px;
            line-height: 28px;
            background:#fff;
            z-index: 22;
            max-height:200px;
            overflow-y: auto;
            // box-shadow: 0px 1px 3px 1px $light-gray-color;
            // box-shadow: 0 3px 9px rgba(0, 0, 0, .2);
            box-shadow: 2px 2px 9px rgba(0,0,0,.5);
            >li{
                padding-left: 10px;
                font-size: 12px;
                cursor: pointer;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space:nowrap;
                &:hover,.active{
                    background:#F3F3F3
                }
            }
        }
        .more{
            display: inline-block;
            width: 0;
            height: 0;
            border: 4px solid;
            border-color: #5C5C65 transparent transparent transparent;
            cursor: pointer;
        }
    }
    .tool-spam{
        cursor: pointer;
    }
    .tool-item-set{
        margin-right:0;
        margin-top:-5px;
    }
    .toolsetting{
        width:352px;
        // height:146px;
        height: 94px;
        background: #fff;
        padding: 10px 18px 32px 20px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, .4);  
        font-size:0;      
        .item{
            padding-top:20px;
        }
        label{
            color:#84848B;
            font-size:12px;
            width: 126px;            
            display: inline-block;
        }
        .setting-btn{
            display: inline-block;
            width:94px;
            height:32px;
            line-height: 32px;
            text-align:center;
            border:1px solid #B8B8B8;
            font-size: 12px;
            color:#434354;
            cursor: pointer;
            &:first-child{
                border-right:0;
            }
            &.active{
                background: #457EEC;
                border-color:#457EEC;
                color:#fff;
            }
        }
    }
}
</style>






// WEBPACK FOOTER //
// src/components/mailtoolbar.vue